import Button from "@/Atoms/Input/Button";
import styles from './Modal.module.scss'

export type ModalProps = {
  onSubmit?: (result: any) => Promise<any>
  onClose?: () => void
  isOpen?: boolean,
}
const Modal = (
  {
    title,
    children,
    onCancel,
    className,
    ...props
  }: {
    title: string,
    children: any,
    className?: string,
    onCancel?: () => void
}) => {

  return <div className={[styles.modal, className].join(' ')} {...props}>
    <div className={styles.dialog}>
      <h2>{title}</h2>
      {onCancel && <Button onClick={() => onCancel()} className={styles.close}>
        <i className="fa-solid fa-xmark"></i>
      </Button>}
      {children}
    </div>
  </div>

}


export default Modal;
